var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSadFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_909_63976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 89C72.4345 89 89 72.4345 89 52C89 31.5655 72.4345 15 52 15C31.5655 15 15 31.5655 15 52C15 72.4345 31.5655 89 52 89Z",
    fill: "#748E98"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 92C75.7482 92 95 72.7482 95 49C95 25.2518 75.7482 6 52 6C28.2518 6 9 25.2518 9 49C9 72.7482 28.2518 92 52 92Z",
    fill: "#41298F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3975 92C61.3279 92 68 89 70 88C70 85.4824 69.5528 79.0559 62.2351 74.2515C54.8486 69.4018 55.3443 31.61 60.2939 23.6283C65.2435 15.6467 61.4466 6 52.3975 6C28.4297 6 9 25.2518 9 49C9 72.7482 28.4297 92 52.3975 92Z",
    fill: "#1A055D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3348 80.4904C69.6419 80.4904 83.6721 66.4603 83.6721 49.1532C83.6721 31.8461 69.6419 17.8159 52.3348 17.8159C35.0277 17.8159 20.9976 31.8461 20.9976 49.1532C20.9976 66.4603 35.0277 80.4904 52.3348 80.4904Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3348 80.4904C54.088 80.4904 55.8076 80.3464 57.4824 80.0697C43.1979 77.7852 30.9073 64.707 30.9073 49.1532C30.9073 33.5833 42.7789 20.7905 57.4364 18.2291C55.7762 17.9573 54.072 17.8159 52.3348 17.8159C35.0277 17.8159 20.9976 31.8461 20.9976 49.1532C20.9976 66.4603 35.0277 80.4904 52.3348 80.4904Z",
    fill: "#F0F2F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3198 80C69.4406 80 83.3198 66.1208 83.3198 49C83.3198 31.8792 69.4406 18 52.3198 18C35.199 18 21.3198 31.8792 21.3198 49C21.3198 66.1208 35.199 80 52.3198 80Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3198 80C54.0542 80 55.7552 79.8576 57.412 79.5838C43.2813 77.3239 31.123 64.3865 31.123 49C31.123 33.5977 42.8668 20.9425 57.3665 18.4087C55.7241 18.1398 54.0383 18 52.3198 18C35.199 18 21.3198 31.8792 21.3198 49C21.3198 66.1208 35.199 80 52.3198 80Z",
    fill: "#F0F2F6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35226,
    d: "M36.9741 57.2597C40.0852 57.2597 42.6073 55.2595 42.6073 52.792C42.6073 50.3245 40.0852 48.3242 36.9741 48.3242C33.8629 48.3242 31.3408 50.3245 31.3408 52.792C31.3408 55.2595 33.8629 57.2597 36.9741 57.2597Z",
    fill: "#FF4A6A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35226,
    d: "M67.6655 57.2597C70.7766 57.2597 73.2987 55.2595 73.2987 52.792C73.2987 50.3245 70.7766 48.3242 67.6655 48.3242C64.5543 48.3242 62.0322 50.3245 62.0322 52.792C62.0322 55.2595 64.5543 57.2597 67.6655 57.2597Z",
    fill: "#FF4A6A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1891 44.8892C39.4855 44.8892 38.915 45.4596 38.915 46.1632V48.4941C38.915 49.1977 39.4855 49.7682 40.1891 49.7682C40.8927 49.7682 41.4631 49.1977 41.4631 48.4941V46.1632C41.4631 45.4596 40.8927 44.8892 40.1891 44.8892Z",
    fill: "#2A3247"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4508 44.8892C63.7472 44.8892 63.1768 45.4596 63.1768 46.1632V48.4941C63.1768 49.1977 63.7472 49.7682 64.4508 49.7682C65.1544 49.7682 65.7248 49.1977 65.7248 48.4941V46.1632C65.7248 45.4596 65.1544 44.8892 64.4508 44.8892Z",
    fill: "#2A3247"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5231 60.0005L56.5075 59.975C57.3354 59.9724 58.0036 59.4822 58 58.8801L57.9825 55.9766C57.9691 53.7711 55.5001 51.991 52.4674 52.0005C49.4346 52.0102 46.9871 53.806 47.0001 56.0116L47.0176 58.915C47.021 59.5173 47.695 60.0031 48.5231 60.0005Z",
    fill: "#2A3247"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_909_63976",
    x: 0,
    y: 0,
    width: 104,
    height: 104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_909_63976"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadFace);
export default __webpack_public_path__ + "static/media/sad_face.4ca9e95b19a5af375d75326019b13632.svg";
export { ForwardRef as ReactComponent };